<template>
  <footer class="footer">
    <a :href="mailto" class="footer__contact"></a>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheFooter',
  computed: {
    ...mapGetters({
      email: 'footer/getEmail'
    }),
    mailto () {
      return `mailto: ${this.email}`
    }
  }
}
</script>

<style lang="scss">
.footer{

}
</style>
